import React from "react";
import {
	GridApi,
	RowNode,
	ICellRendererParams,
	CellClickedEvent,
	RowGroupOpenedEvent,
	StartEditingCellParams,
} from "ag-grid-community";
import {Grid} from ".";

function selectCellWithBlink(dataGrid: Grid, key: string, value: any, colId: string) {
	setTimeout(() => {
		const gridApi: GridApi = dataGrid.state.api;
		gridApi.forEachNode((node: RowNode, index: number) => {
			if (node.data[key] === value) {
				// gridApi.setFocusedCell(index, colId);
				setTimeout(() => {
					gridApi.flashCells({ rowNodes: [node], columns: [colId] });
				}, 200);
			}
		});
	}, 300);
}

function findNode(gridApi: GridApi, iterator: (node: RowNode) => boolean): RowNode {
	let found: RowNode;
	gridApi.forEachNode((node: RowNode) => {
		if (iterator(node)) {
			found = node;
			return found;
		}
	});
	return found;
}

// when grouped, data is missing
function getParamsData<T>(params: ICellRendererParams | CellClickedEvent | RowGroupOpenedEvent): T {
	if (!params) return null;
	return params.data || params.api.getRowNode(params.rowIndex.toString())?.data;
}

function startEditingCell(api: GridApi, params: StartEditingCellParams) {
	api.clearRangeSelection();
	api.clearFocusedCell();
	api.ensureColumnVisible(params.colKey);
	api.setFocusedCell(params.rowIndex, params.colKey);
	api.startEditingCell(params);
}

// function focusRow(dataView: DataView, entity: ENTITY, data: CorreEntity) {
// 	setTimeout(() => {
// 		if (!!dataView && !!dataView?.grid()) {
// 			const gridApi: GridApi = dataView.grid().state.gridApi;
// 			focusRowApi(gridApi, entity, data);
// 		}
// 	}, 0);
// }

function focusRowApi(gridApi: GridApi, data) {
	setTimeout(() => {
		const idColData = data.id;
		const node: RowNode = findNode(gridApi, (node: RowNode) => {
			var rowNodeFound = node.allLeafChildren?.find((child) => {
				return child.data.id === idColData;
			});

			if (rowNodeFound) {
				return true;
			}

			return node?.data && node.data.id === idColData;
		});

		if (node) {
			var parent = node.parent;
			while (parent) {
				parent.setExpanded(true);
				parent = parent.parent;
			}

			gridApi.ensureNodeVisible(node, "middle");
			gridApi.selectNode(node, true, true);
			gridApi.flashCells({ rowNodes: [node] });
		}
	}, 0);
}

const GridUtils = {
	findNode,
	focusRowApi,
	selectCellWithBlink,
	startEditingCell,
	getParamsData,
};

export default GridUtils;
